export default __webpack_public_path__ + "static/media/motor_grader.bfeaaeb2.jpg";